export const dateFormatter = new Intl.DateTimeFormat('nl-NL', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export const numberFormatter = new Intl.NumberFormat('nl-NL', {
  maximumFractionDigits: 2,
});
